import { Box } from 'shared/mui/Box';
import { TooltipWithInfoIcon } from 'shared/mui/Tooltip';
import { TypographyTitle } from 'shared/mui/Typography';
import { TypographySize } from 'shared/mui/Typography/TypographyTitle/TypographyTitle';

export type PageHeaderTitleProps = {
  titleText: React.ReactNode;
  tooltipText?: string;
  titleSize?: TypographySize;
};

export const PageHeaderTitle = ({
  titleText,
  tooltipText,
  titleSize = 'large',
}: PageHeaderTitleProps): JSX.Element => (
  <Box alignItems="center" display="flex" mt={1} pb={0}>
    <TypographyTitle mr={1} size={titleSize}>
      {titleText}
    </TypographyTitle>
    {tooltipText && <TooltipWithInfoIcon iconSize={24} tooltipText={tooltipText} />}
  </Box>
);
